module.exports = __webpack_public_path__ + "static/img/6538_phase_function_Paper_PointsHejduk_Prediction.26aa931.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6538_phase_function_Paper_PointsHejduk_Prediction.png
// module id = d/Hc
// module chunks = 0